import { Component } from "@angular/core";
import { ViewController, NavParams } from "ionic-angular";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs/Subscription";
import { OnDestroy } from "@angular/core/src/metadata/lifecycle_hooks";
import { take } from "rxjs/operators";
import { DiaprofilPatient } from "../../app/models/diaprofil-patient";
import {
  TopicItem,
  DiaprofilTopic,
  RelevantSupportActionModalType,
  ISupportFor,
  IScoreResult,
  Score
} from "../../app/models/types";
import { SupportAction } from "../../app/models/support-action";
import { AppState } from "../../app/models/app.state";
import { ManualItem } from "../../app/models/manual-item";
import { ManualItemsService } from "../../app/services/manual-items.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "relevant-support-actions-modal",
  templateUrl: "relevant-support-actions.modal.html"
})
export class RelevantSupportActionsModal implements OnDestroy {
  item: TopicItem;
  patient: DiaprofilPatient;
  availableTopics: DiaprofilTopic[] = [];
  selectedTopics: DiaprofilTopic[] = [];
  modalType: RelevantSupportActionModalType;
  modalTitle: string;
  supportFor: ISupportFor;
  scoreResults: { [key in Score]: IScoreResult };
  supportActions: SupportAction[] = [];
  supportActionSubscription: Subscription;
  manualItemSubscription: Subscription;
  manualItem: ManualItem;
  displayInfoToHCP: boolean = false;
  constructor(
    public viewCtrl: ViewController,
    public sanitizer: DomSanitizer,
    private navParams: NavParams,
    private store: Store<AppState>,
    private manual: ManualItemsService
  ) {
    this.patient = (this.navParams.get("patient") || {}) as DiaprofilPatient;
    this.modalType = (this.navParams.get("supportForType") ||
      "PRO_ITEM") as RelevantSupportActionModalType;
    this.modalTitle = this.navParams.get("modalTitle");
    this.supportFor = (this.navParams.get("supportFor") || {}) as ISupportFor;
    this.scoreResults = (this.navParams.get("scoreResults") || []) as {
      [key in Score]: IScoreResult
    };
    const relManualItem = this.manual.manualItems.find(item =>
      item.isRelevant({
        supportFor: this.supportFor
      })
    );
    this.manualItem = relManualItem !== undefined ? relManualItem : null;
    this.supportActionSubscription = this.store
      .select(state => state.supportActions)
      .pipe(take(1))
      .subscribe(actions => {
        const relActions = actions
          .map(action => new SupportAction(action))
          .filter(action =>
            action.isRelevant({
              diagnosis: this.patient.diagnosis,
              municipality: this.patient.municipality,
              supportFor: this.supportFor
            })
          );
        this.availableTopics = relActions.reduce((prev, relAction) => {
          relAction.actionTopics.map(topic => {
            if (
              !prev.includes(topic) &&
              (this.manualItem === null ||
                this.manualItem.relevantTopics.includes(topic))
            ) {
              prev.push(topic);
            }
          });
          return prev;
        }, []);
        this.supportActions = relActions;
      });
    this.selectedTopics =
      this.manualItem !== null &&
      this.manualItem.defaultTopics !== null &&
      this.manualItem.defaultTopics !== undefined
        ? this.manualItem.defaultTopics
        : []; // We
  }

  toggleInfoToHCP(event$) {
    event.preventDefault();
    this.displayInfoToHCP = this.displayInfoToHCP ? false : true; // Toogle boolean value
  }

  toggleTopic(topic) {
    if (topic === "ALL") {
      if (this.selectedTopics.length === this.availableTopics.length) {
        this.selectedTopics = [];
      } else {
        this.selectedTopics = this.availableTopics;
      }
    } else {
      if (this.selectedTopics.includes(topic)) {
        this.selectedTopics = this.selectedTopics.filter(
          curTopic => curTopic !== topic
        );
      } else {
        this.selectedTopics.push(topic);
      }
    }
  }

  getTopicIcon(topic): "eye-off" | "eye" {
    if (topic === "ALL") {
      if (this.selectedTopics.length === this.availableTopics.length) {
        return "eye";
      } else {
        return "eye-off";
      }
    }
    return this.selectedTopics.includes(topic) ? "eye" : "eye-off";
  }

  ngOnDestroy() {
    this.supportActionSubscription.unsubscribe();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modals/relevant-support-actions.modal/relevant-support-actions.modal.ts